
export default function selectAllSubCategories(stuffCategories, chosenCategory) {

    let allSubCategories = [];


    for (let i = 0; i < stuffCategories.length; i++) {
        for (let j = 0; j < stuffCategories[i].subcategories.length; j++) {
            if (stuffCategories[i].subcategories[j].name === chosenCategory) {
                for (let k = 0; k < stuffCategories[i].subcategories[j].subcategories.length; k++) {
                    allSubCategories.push(stuffCategories[i].subcategories[j].subcategories[k].name)
                }
            }
        }
    }

    return allSubCategories

}